import { render } from "./CompraViews.vue?vue&type=template&id=32911b7e&scoped=true"
import script from "./CompraViews.vue?vue&type=script&lang=js"
export * from "./CompraViews.vue?vue&type=script&lang=js"

import "./CompraViews.vue?vue&type=style&index=0&id=32911b7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32911b7e"]])

export default __exports__